<script lang="ts" setup>
	import { message, notification } from 'ant-design-vue'
	import type { ThemeConfig } from 'ant-design-vue/lib/config-provider/context'

	const { initializeSdk } = useMcaSdk()
	const { decryptString, toLower } = useUtils()
	const styleThemeConfig: ThemeConfig = {
		token: {
			colorPrimary: '#4FBFA3',
			colorLink: '#4AA695',
			colorLinkHover: '#4FBFA3',
			fontFamily: 'Metropolis,-apple-system,BlinkMacSystemFont,sans-serif'
		},
		components: {
			Button: {
				controlHeight: 54,
				colorBorderBg: 'unset',
				colorBgContainer: 'unset',
				colorBorder: '#EAECF0'
			},
			Select: {
				controlHeight: 44
			},
			Dropdown: {
				controlHeight: 44
			},
			Table: {
				colorTextHeading: '#475467',
				fontWeightStrong: 500,
				colorBgContainer: '#fff'
			}
		}
	}
	message.config({
		duration: 3,
		maxCount: 3
	})
	notification.config({
		maxCount: 1,
		duration: 3
	})
	const source = computed(() => toLower(String(useRoute().query?.utm_source || '') ?? '') as ChannelSource)
	const referrer = computed(() => toLower(String(useRoute().query?.referrer || '') ?? ''))
	const campaignCode = computed(() => toLower(String(useRoute().query?.campaign || '') ?? ''))
	const { marketingChannels } = useStore()

	const { params } = useRoute()
	const { storeItem: setSource } = useDraft('channel_source')
	const { storeItem: setReferrer } = useDraft('referrer')
	const { storeItem: setCampaignCode } = useDraft('campaign_code')

	onMounted(() => {
		if (import.meta.client) {
			const inspectionSdk = String(useRoute().query?.inspectionSdk ?? '')
			if (inspectionSdk) {
				const decryptedData = decryptString<Record<string, string>>(inspectionSdk)
				if (Object.values(decryptedData).length) {
					initializeSdk({
						...decryptedData,
						onClose: () => {
							useRouter().replace({
								query: {}
							})
						},
						callback: () => {
							useRouter().replace({
								query: {}
							})
						}
					})
				}
			}

			// Store campaign if there's a campaign code attached to the query
			if (campaignCode.value) {
				setCampaignCode(String(campaignCode.value))
			}
			// Check for user source
			if (marketingChannels.includes(source.value)) {
				setSource(source.value)
			}
			if (referrer.value) {
				setReferrer(referrer.value)
			}
		}
	})
</script>

<template>
	<nuxt-layout>
		<nuxt-loading-indicator color="#4FBFA3" />
		<layout-offline />
		<VitePwaManifest />
		<tools-pwa-update-prompt />
		<a-config-provider :theme="styleThemeConfig">
			<a-style-provider hash-priority="high">
				<nuxt-page :key="encryptData(params)" />
			</a-style-provider>
		</a-config-provider>
	</nuxt-layout>
</template>
